import { type ReactNode } from 'react'
import { EndingCollapse } from './EndingCollapse'

export const PlaybookEpilogue = ({
  children,
  title,
  isExpanded,
  prerender = false,
  afterContent,
}: {
  children: ReactNode
  title: string
  isExpanded: boolean
  // Mount the body collapsed (height 0) even while not expanded, so expanding
  // is a pure height animation. Set after the end-cap nav has rendered — see
  // the prerender flag in PlaybookBranchNodeMarkdownContent.
  prerender?: boolean
  // Rendered at the very end of the expanded epilogue, after its prose — the
  // end-of-scenario cap (timeline diagram + reviewer box) the reader lands on
  // once they finish reading.
  afterContent?: ReactNode
}) => {
  // No spacing of its own: the endings wrapper in
  // PlaybookBranchNodeMarkdownContent owns the gap below the end-cap nav,
  // shared with the POV collapses so all three endings open at the same spot.
  return (
    <EndingCollapse open={isExpanded}>
      {/* First-heading margin-top zeroed (child selector outranks the global
          .good-ending-text h1 rule) so the body starts flush at the wrapper's
          75px gap below the end-cap nav. */}
      {(isExpanded || prerender) && <div data-playbook-galaxy-start="true" className="[&>h1:first-child]:mt-0">
        <h1 id="playbook-epilogue">{title}</h1>
        {children}
        {afterContent}
      </div>}
    </EndingCollapse>
  )
}
